import { motion } from "framer-motion";
import type { ReactNode } from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

import { Logo } from "./logo";

interface PageEditorPreviewProps {
  content: string;
}

function DefaultPage({ children }: { children: ReactNode }) {
  return (
    <div className="relative h-full">
      <div className="border-b flex justify-between items-center py-4 px-16 mb-8">
        <Logo className="w-16 h-16" />

        <h1>THIS IS THE NAVIGATION BAR DISPLAYED ON ALL PAGES</h1>
      </div>
      <div className="px-32">{children}</div>
    </div>
  );
}

export function PageEditorPreview(props: PageEditorPreviewProps) {
  return (
    <DefaultPage>
      <Markdown content={props.content} />
    </DefaultPage>
  );
}

export function Markdown(props: { content: string }) {
  return (
    <motion.div
      className="md"
      initial={{ opacity: 0, scale: 1 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, y: 4 }}
      transition={{ duration: 0.15, ease: "easeOut" }}
    >
      <ReactMarkdown rehypePlugins={[rehypeRaw]}>{props.content}</ReactMarkdown>
    </motion.div>
  );
}
